export const MEDICAL_PLAN_REQUIRED_MESSAGE = 'Selecione um convênio';

function getEntries(value) {
  if (Array.isArray(value)) {
    return value;
  }

  if (value && typeof value.toArray === 'function') {
    return value.toArray();
  }

  return [];
}

function normalizeMedicalPlanId(id) {
  if (typeof id !== 'number' && typeof id !== 'string') {
    return null;
  }

  const numericId = Number(id);
  return Number.isInteger(numericId) && numericId > 0 ? numericId : null;
}

export function getMedicalPlanId(item) {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const associationPlanId = normalizeMedicalPlanId(item.medical_plan_id);
  if (associationPlanId) {
    return associationPlanId;
  }

  const nestedPlanId = item.medical_plan
    ? normalizeMedicalPlanId(item.medical_plan.id)
    : null;
  if (nestedPlanId) {
    return nestedPlanId;
  }

  // The multiple-plan selector returns MedicalPlan records with these model fields.
  // A procedure_medical_plan association has its own `id`, which is never a plan id.
  if (
    normalizeMedicalPlanId(item.medical_plan_table_id)
    && normalizeMedicalPlanId(item.institution_id)
  ) {
    return normalizeMedicalPlanId(item.id);
  }

  return null;
}

export function getValidMedicalPlans(value) {
  return getEntries(value).filter((item) => getMedicalPlanId(item));
}

export function hasValidMedicalPlan(value) {
  return getValidMedicalPlans(value).length > 0;
}

export function validateMedicalPlans(rule, value, callback) {
  if (hasValidMedicalPlan(value)) {
    callback();
    return;
  }

  callback(MEDICAL_PLAN_REQUIRED_MESSAGE);
}

export function serializeMedicalPlans(value) {
  return getValidMedicalPlans(value).map((item) => ({
    medical_plan_id: getMedicalPlanId(item),
    code: item.patient_medical_plan_code,
    password: item.password,
  }));
}
